function bindHeaderCollapses(Collapse) {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const toggles = header.querySelectorAll(
    '[data-bs-toggle="collapse"], [data-toggle="collapse"]'
  );

  const boundAttr = 'data-header-bound';
  const mobileMq = window.matchMedia('(max-width: 1198.98px)');

  const caretToggles = header.querySelectorAll('.nav__caret');
  caretToggles.forEach((caret) => {
    const link = caret.parentElement.querySelector('.nav__link');
    if (link) {
      link.addEventListener('click', (e) => {
        if (mobileMq.matches) {
          e.preventDefault();
          e.stopPropagation();
          caret.click();
        }
      });
    }
  });

  toggles.forEach((btn) => {
    const targetSel =
      btn.getAttribute('data-bs-target') ||
      btn.getAttribute('data-target') ||
      btn.getAttribute('href');

    if (!targetSel || !targetSel.startsWith('#')) return;

    const target = document.querySelector(targetSel);
    if (!target || target.hasAttribute(boundAttr)) return;

    const coll = new Collapse(target, { toggle: false });
    const isMainToggle = btn.classList.contains('header__toggle');

    if (isMainToggle) {
      target.classList.add('is-main-nav-drawer');
    }

    function closeOtherSubmenus() {
      if (!mobileMq.matches || isMainToggle) return;

      const currentItem = btn.closest('.nav__item');
      if (!currentItem || !currentItem.parentElement) return;

      const siblings = Array.from(currentItem.parentElement.children);

      siblings.forEach((sibling) => {
        if (sibling === currentItem) return;

        const openDropdown = sibling.querySelector('.nav__dropdown.show');
        const siblingBtn = sibling.querySelector('.nav__caret');

        if (openDropdown) {
          const siblingCollapse = Collapse.getOrCreateInstance(openDropdown, {
            toggle: false,
          });
          siblingCollapse.hide();
        }

        if (siblingBtn) {
          siblingBtn.setAttribute('aria-expanded', 'false');
        }

        sibling.classList.remove('is-submenu-open');
      });
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (!isMainToggle && mobileMq.matches && !target.classList.contains('show')) {
        closeOtherSubmenus();
      }

      coll.toggle();
    });

    target.addEventListener('shown.bs.collapse', (e) => {
      if (e.target !== target) return;

      btn.setAttribute('aria-expanded', 'true');

      if (isMainToggle) {
        document.body.classList.add('nav-open');
      } else {
        const item = btn.closest('.nav__item');
        if (item) item.classList.add('is-submenu-open');
      }
    });

    target.addEventListener('hidden.bs.collapse', (e) => {
      if (e.target !== target) return;

      btn.setAttribute('aria-expanded', 'false');

      if (isMainToggle) {
        document.body.classList.remove('nav-open');

        const openSubmenus = target.querySelectorAll('.nav__dropdown.show');
        openSubmenus.forEach((submenu) => {
          const submenuCollapse = Collapse.getOrCreateInstance(submenu, {
            toggle: false,
          });
          submenuCollapse.hide();
        });

        target.querySelectorAll('.nav__item.is-submenu-open').forEach((item) => {
          item.classList.remove('is-submenu-open');
        });

        target.querySelectorAll('.nav__caret[aria-expanded="true"]').forEach((caret) => {
          caret.setAttribute('aria-expanded', 'false');
        });
      } else {
        const item = btn.closest('.nav__item');
        if (item) item.classList.remove('is-submenu-open');
      }
    });

    target.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-nav-close]');
      if (a) coll.hide();
    });

    const onChange = () => {
      if (!mobileMq.matches) {
        coll.hide();
      }
    };

    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onChange);
    else mobileMq.addListener(onChange);

    target.setAttribute(boundAttr, '1');
  });
}

function enableFixedAfterScroll() {
  const header = document.querySelector('.site-header');
  if (!header || header.hasAttribute('data-fixed-ready')) return;

  const setHeaderOffset = () => {
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  };

  const setFixedState = () => {
    header.classList.toggle('is-fixed', window.scrollY > 0);
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      setFixedState();
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  const onResize = () => {
    setHeaderOffset();
  };
  window.addEventListener('resize', onResize);

  header.addEventListener('shown.bs.collapse', setHeaderOffset);
  header.addEventListener('hidden.bs.collapse', setHeaderOffset);

  ['shopify:section:load', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder']
    .forEach(evt => document.addEventListener(evt, onResize));

  setHeaderOffset();
  setFixedState();

  header.setAttribute('data-fixed-ready', '1');
}

function initMegaMenuPreview() {
  const megaMenus = document.querySelectorAll('[data-mega-menu]');

  megaMenus.forEach((menu) => {
    const previewLink = menu.querySelector('[data-preview-link-el]');
    const previewImage = menu.querySelector('[data-preview-image-el]');
    const previewTitle = menu.querySelector('[data-preview-title-el]');
    const previewBadge = menu.querySelector('[data-preview-badge-el]');
    const items = menu.querySelectorAll('[data-preview-source="true"]');

    if (!previewLink || !previewImage || !previewTitle || !items.length) return;

    const DEFAULT_IMAGE = '/assets/image-default-hover.png';

const setPreview = (item, highlight = true) => {
  const title = item.getAttribute('data-preview-name') || item.textContent.trim() || '';
  const image = item.getAttribute('data-preview-src') || DEFAULT_IMAGE;
  const url = item.getAttribute('data-preview-url') || item.getAttribute('href') || '#';
  const badgeLabel = item.getAttribute('data-preview-badge-label');
  const badgeIcon = item.getAttribute('data-preview-badge-icon');

  previewTitle.textContent = title;
  previewLink.setAttribute('href', url);

  previewImage.src = image;
  previewImage.alt = title;
  previewImage.style.display = 'block';

  if (previewBadge) {
    if (badgeLabel) {
      const textEl = previewBadge.querySelector('.text-tirty');
      if (textEl) textEl.textContent = badgeLabel;

      const iconEl = previewBadge.querySelector('.bestseller-tag__icon');
      if (iconEl) {
        if (badgeIcon) {
          iconEl.innerHTML = `<img src="${badgeIcon}" alt="${badgeLabel}" width="16" height="16" loading="lazy">`;
          iconEl.style.display = '';
        } else {
          iconEl.innerHTML = '';
          iconEl.style.display = 'none';
        }
      }
      previewBadge.classList.remove('d-none');
    } else {
      previewBadge.classList.add('d-none');
    }
  }

  items.forEach((link) => link.classList.remove('is-active'));
  if (highlight) {
    item.classList.add('is-active');
  }
};

    const defaultItem =
      menu.querySelector('[data-preview-source="true"][data-preview-default="true"]') || items[0];

    if (defaultItem) {
      const isCurrent = defaultItem.classList.contains('is-current');
      setPreview(defaultItem, isCurrent);
    }

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => setPreview(item));
      item.addEventListener('focus', () => setPreview(item));
    });
  });
}

export function initHeader(Collapse) {
  bindHeaderCollapses(Collapse);
  enableFixedAfterScroll();
  initMegaMenuPreview();
}

document.addEventListener('DOMContentLoaded', function () {
  initMegaMenuPreview();

  const header = document.querySelector('.site-header');
  if (!header) return;
  const drawer = header.querySelector('[data-search-drawer]');
  const toggles = header.querySelectorAll('.js-search-toggle');
  if (!drawer || !toggles.length) return;

  const input = drawer.querySelector('.header-search__input');
  const closers = drawer.querySelectorAll('.js-search-close');

  function openSearch() {
    drawer.hidden = false;
    drawer.classList.add('is-prep');
    void drawer.offsetHeight;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      drawer.classList.remove('is-prep');
      toggles.forEach(b => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => input && input.focus(), 120);
      document.addEventListener('keydown', onEsc);
      document.addEventListener('click', onOutside, true);
    });
  }

  function closeSearch() {
    drawer.classList.remove('is-open');
    toggles.forEach(b => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 260);
    document.removeEventListener('keydown', onEsc);
    document.removeEventListener('click', onOutside, true);
  }

  function toggle() {
    drawer.classList.contains('is-open') ? closeSearch() : openSearch();
  }

  function onEsc(e) {
    if (e.key === 'Escape') closeSearch();
  }

  function onOutside(e) {
    const clickedToggle = [...toggles].some(t => t.contains(e.target));
    if (!drawer.contains(e.target) && !clickedToggle) closeSearch();
  }

  toggles.forEach(b => b.addEventListener('click', (e) => {
    e.preventDefault();
    toggle();
  }));

  closers.forEach(b => b.addEventListener('click', closeSearch));
});